<template>
  <div class="product-feeds__page">
    <div class="d-flex align-center justify-space-between mb-4">
      <h1 class="my-0">Product Feeds</h1>
      <div class="d-flex align-center ml-auto" style="gap: 12px">
        <v-btn @click="getResources" outlined color="primary">
          <v-icon left>mdi-refresh</v-icon>
          Refresh
        </v-btn>
        <v-btn @click="$router.push({ name: 'website.product-feeds-v2.create' })" color="primary"
          >Create Product Feed</v-btn
        >
      </div>
    </div>
    <!-- <p>
      A product feed, otherwise known as a data feed contains all of your product's information. You can upload it to
      shopping channels like Google Shopping and Facebook to communicate all the information your product listings will
      contain. If having any changes, product feeds will be updated automatically at 11:00 AM every day.
    </p> -->
    <v-card class="pa-4" rounded="lg">
      <Resource
        :document="document"
        :searchable="searchableField"
        :columns="columns"
        :update-router-callback="getUpdateRouterData"
        :routeName="updateRouteName"
        :callback-action="handleCallbackAction"
      />
      <div class="d-flex justify-space-between mt-4">
        <limit-page :callback="setLimit" />
        <pagination :length="lengthPage" v-if="!$parent.isLoading && document" :page.sync="page"></pagination>
      </div>
    </v-card>

    <!-- Confirmation Dialog for Re-sync -->
    <v-dialog persistent v-model="confirmResyncDialog" width="450" style="transform-origin: center top">
      <v-card relative rounded="lg" class="pa-4">
        <div class="px-0 pt-0" style="font-size: 20px; margin-bottom: 16px;">Confirm Re-sync</div>
        <div
          class="close-icon"
          @click="confirmResyncDialog = false"
          style="position: absolute; right: 16px; top: 16px; cursor: pointer;"
        >
          <v-icon>fas fa-times</v-icon>
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-card-text class="px-0">
          Are you sure you want to re-sync this product feed?
        </v-card-text>
        <v-divider class="my-3"></v-divider>
        <v-card-actions class="px-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn @click="confirmResyncDialog = false">Cancel</v-btn>
          <v-btn :loading="isResyncing" color="primary" @click="submitResync">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { productApi } from '@/apis/product';
import Resource from '@/components/Resources';
import filter from '@/const/filters/product-filter';
import resourceListMixin from '@/mixins/resource-list';

export default {
  components: { Resource },
  mixins: [resourceListMixin],
  data() {
    return {
      resourceType: 'product-feeds-v2',
      // page: 1,
      length: 1,
      action: '',
      count: 1,
      confirmResyncDialog: false,
      resyncTargetId: null,
      isResyncing: false,
      columns: {
        Name: {
          // blankLabel: true,
          kind: 'title',
          field: 'name',
        },
        'Total Product': {
          field: 'totalProduct',
          kind: 'text',
        },
        'Last Refreshed At': {
          field: 'startDate',
          kind: 'datetime',
        },
        'Product Feed Url': {
          field: 'feedUrl',
          kind: 'url',
        },
        'File Type': {
          field: 'feedType',
          kind: 'text',
        },
        'File Format': {
          field: 'feedFileFormat',
          kind: 'text',
        },
        Status: {
          field: 'status',
          kind: 'status-feed',
        },
        Actions: {
          kind: 'action',
          blankLabel: false,
          listAction: [
            {
              name: 'resync',
            },
          ],
        },
      },
      searchableField: 'with title',
      sortable: [],
      filter,
      updateRouteName: 'website.product-feeds-v2.update',
      isLoadingCollection: false,
    };
  },
  methods: {
    handleCallbackAction(action, id) {
      if (action.action === 'resync') {
        this.resyncTargetId = id;
        this.confirmResyncDialog = true;
      }
    },
    async submitResync() {
      if (!this.resyncTargetId) return;
      this.isResyncing = true;
      try {
        await productApi.resyncProductFeed(this.resyncTargetId);
        this.$store.commit('setMessages', {
          messages: 'Re-sync product feed successfully!',
          type: 'success',
        });
        this.getResources();
      } catch (error) {
        console.error(error);
        this.$store.commit('setMessages', {
          messages: typeof error === 'string' ? error : 'Failed to re-sync product feed.',
          type: 'error',
        });
      } finally {
        this.isResyncing = false;
        this.confirmResyncDialog = false;
        this.resyncTargetId = null;
      }
    },
  },
};
</script>
